import React from 'react';
import PropTypes from 'prop-types';
import { mask } from '../../utils/helpers';

function ObfuscateReviewField({ children, uiSchema }) {
  return (
    <div className="review-row">
      <dt>{uiSchema?.['ui:title']}</dt>
      <dd>{mask(children?.props?.formData)}</dd>
    </div>
  );
}

ObfuscateReviewField.propTypes = {
  children: PropTypes.node.isRequired,
  uiSchema: PropTypes.shape({
    'ui:title': PropTypes.string.isRequired,
  }).isRequired,
};
export default ObfuscateReviewField;
